import { $http } from '@/utils';
import { kebabCase } from 'lodash';

/**
 * @namespace Service
 * @class File
 * @exports Service/File
 * @description API File Service
 * @date 2023/01/19
 * @license no license
 * @copywrite Answers In Retirement Limited
 */
export default {
	/**
	 * @name getSiteConfig
	 * @description Get site config
	 * @returns {Object} Promise a http response
	 */
	getSiteConfig: () => $http.get(`cms/site`),

    /**
	 * @name getDbContent
	 * @description Get db content
	 * @returns {Object} Promise a http response
	 */
    getDbContent(name, domain = 'default', cache = true) {
		const version = process.env?.VUE_APP_VERSION || null;
		return $http.get(`cms/db-content/${name}/${version}`, {
            baseURL: process.env?.VUE_APP_CACHE_API_URL,
			cache,
			cachePath: `db-content-${kebabCase(name)}-${version}-${domain}`
		});
	},

	/**
	 * @name updateJson
	 * @description Get site config
	 * @returns {Object} Promise a http response
	 */
	updateJson: (payload) => $http.post(`file/json`, payload),

	/**
	 * @name getJson
	 * @description Get Json
	 * @returns {Object} Promise a http response
	 */
	getJson: (params) => $http.get(`file`, { params }).then(({ data }) => $http.get(data.preSignedUrl)),

	/**
	 * @name eligibilityAndPrioritiesPdf
	 * @description Print eligibility & priorities tool pdf
	 * @returns {Object} Promise a http response
	 */
	eligibilityAndPrioritiesPdf: (payload) => $http.post(`eligibility-and-priorities/pdf`, payload),

	/**
	 * @name productComparisonPdf
	 * @description Print product comparison tool pdf
	 * @returns {Object} Promise a http response
	 */
	productComparisonPdf: (payload) => $http.post(`product-comparison/pdf`, payload)
};
